module.exports = __webpack_public_path__ + "static/img/img_verifcode.2acb3528.png";